import React from 'react';
import {Questionnaire} from './Questionnaire';

type Props = {
    onCloseModal: () => void;
    onSubmit: (id: string) => void;
    onGoOutside?: (cbc?: () => void) => void;
    id: string;
};

export const PrioriotyInfoScreen = (props: Props) => {
    return <Questionnaire {...props} />;
};
